// import { MSConstant } from "@/commons/wildcards";
import {MSConstant} from '@/commons/wildcards';
import moment from 'moment';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import i18n from '@/i18ns/i18n';
// import store from '@/stores/store';
import {ModuleContext, ModuleDbOption} from '@/stores/moduleConst';
import {useContextStore} from '@/stores/context';

import numeral from 'numeral';
const mo = moment;
mo.locale('vi');
numeral.register('locale', 'vi', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'nghìn',
    million: 'triệu',
    billion: 'tỷ',
    trillion: 'nghìn tỷ',
  },
  ordinal: function (number) {
    return '.';
  },
  currency: {
    symbol: '', // '₫'
  },
});

// switch between locales
numeral.locale('vi');
/**
 * Xử lý convert từ string sang DateTime
 * @param {String} sDate Chuỗi cần parse
 * @author DNThang - 17.03.2020
 */
const parseStringToDate = function (sDate) {
  if (typeof sDate == 'string') {
    let dte = mo(value);
    if (!dte.isValid()) {
      dte = dte.toDate();
      return dte;
    }
  }
};

const msFormat = {
  /**
   * Format định dạng số với kí tự ngăn cách trên tùy chọn theo báo cáo hoặc các form thường
   * @param {Object} options : tùy chọn hệ thống
   */
  formatSeperator(options) {
    let decimalCharacter = useContextStore().NumberFormat.GeneralDecimalSeparator;
    let digitGroupSeparator = useContextStore().NumberFormat.GeneralGroupSeparator;

    if (options && options.isReport) {
      decimalCharacter = session.GeneralDecimalSeparatorReport;
      digitGroupSeparator = session.GeneralGroupSeparatorReport;
    }

    numeral.localeData().delimiters.decimal = decimalCharacter;
    numeral.localeData().delimiters.thousands = digitGroupSeparator;
  },
  /**
   * Định dạng Time (theo format string truyền vào)
   * @param {DateTime/String} value Giá trị cần format
   * @param {String} formatString Định dạng cần trả ra sau khi format. Nếu không truyền thì sẽ lấy theo session.TimeFormat
   * @author DNThang - 17.03.2020
   */
  formatTime(value, formatString) {
    if (value) {
      let ret = value;
      let dte = value;
      if (typeof dte == 'string') {
        dte = parseStringToDate(dte);
      }

      if (dte instanceof Date) {
        // formatString = formatString ? formatString : session.TimeFormat;
        dte = mo(dte);
        if (dte.isValid()) {
          ret = dte.format(formatString);
        }
      }

      return ret;
    }
  },
  /**
   * Author: ĐVThi
   * 25/02/2021
   * format theo định dạng culture của hệ thống
   */
  formatNull(value, options) {
    if (
      options &&
      options.optionFormat == MSConstant.OptionFormat.EmptyToEmpty &&
      (typeof value === 'undefined' || value === null)
    ) {
      return null;
    }
    // if (typeof value === 'undefined' || value === null) {
    //     return "-";
    // }
    return value;
  },
  /**
   * Format ngày tháng - trước mắt hỗ trợ dd/MM/yyyy
   * Mặc định hỗ trợ định dạng YYYY-MM-DDTHH:mm:ss.SSSSZ (đây là format dữ liệu từ server)
   * Bổ sung thêm hỗ trợ cho định dạng DD/MM/YYYY (do sử dụng từ )
   * @param {Date/String} value
   * Modify by ĐVThi 25/02/2020: sửa lại nếu không có giá trị thì hiển thị "--"
   */
  formatDate(value) {
    if (!value) {
      return '-';
    }

    let ret;
    let dte = value;

    if (!(dte instanceof Date)) {
      if (value) {
        value = value.replace('Z', '');
      }
      dte = mo(value);
      if (!dte.isValid()) {
        const dateFormat = 'DD/MM/YYYY';
        dte = mo(value, dateFormat.toUpperCase());
        if (!dte.isValid()) {
          throw new Error('DEV: value <' + value + '> format Date invalid.');
        }
      }

      dte = new Date(dte.year(), dte.month(), dte.date());
      // dte = dte.toDate();
    }
    ret = dte.toLocaleDateString('vi', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    return ret;
  },

  /**
   * @modified by TVLoi 08.07.2021 - Sửa cách hiển thị. Nếu khác undifined thì mới hiển thị có/không. Ngược lại trả về rỗng. Sửa lỗi 107172
   */
  formatCheckbox(value) {
    if (value) {
      return 'Có';
      return i18n.t('i18nComponent.HeaderOption.Boolean.True');
    } else {
      if (value !== undefined) {
        return 'Không';
        return i18n.t('i18nComponent.HeaderOption.Boolean.False');
      }
    }
    return '';
  },

  formatDateTimeFull(value, format = 'DD/MM/YYYY HH:mm:ss') {
    if (!value) {
      return '-';
    }

    let ret;
    let dte = value;

    if (!(dte instanceof Date)) {
      dte = mo(value);
      if (!dte.isValid()) {
        // let dateFormat = session.DateTimeFormat;
        // dte = mo(value, dateFormat.toUpperCase());
        // if (!dte.isValid()) {
        // 	throw new Error('DEV: value <' + value + '> format Date invalid.');
        // }
      }

      dte = dte.toDate();
    }

    const m = mo(dte);

    ret = m.format(format);

    return ret;
  },
  /**
   * Ngày tháng năng giờ phút (không có giây)
   */
  formatDateTimeFullNotSecond(value, format = 'DD/MM/YYYY HH:mm') {
    if (!value) {
      return '-';
    }

    let ret;
    let dte = value;

    if (!(dte instanceof Date)) {
      dte = mo(value);
      if (!dte.isValid()) {
        // let dateFormat = session.DateTimeFormat;
        // dte = mo(value, dateFormat.toUpperCase());
        // if (!dte.isValid()) {
        // 	throw new Error('DEV: value <' + value + '> format Date invalid.');
        // }
      }

      dte = dte.toDate();
    }

    const m = mo(dte);

    ret = m.format(format);

    return ret;
  },

  formatDateTimeFullReverse(value) {
    if (!value) {
      return '-';
    }

    let ret;
    const format = 'yyyy-MM-DD HH:mm:ss';
    let dte = value;

    if (!(dte instanceof Date)) {
      dte = mo(value);
      if (!dte.isValid()) {
        // let dateFormat = session.DateTimeFormat;
        // dte = mo(value, dateFormat.toUpperCase());
        // if (!dte.isValid()) {
        // 	throw new Error('DEV: value <' + value + '> format Date invalid.');
        // }
      }

      dte = dte.toDate();
    }

    const m = mo(dte);

    ret = m.format(format);

    return ret;
  },

  formatEnum(value, enumName) {
    if (typeof value == 'number' || value || typeof value == 'boolean') {
      let formatValue = Number(value);
      if (Number.isNaN(formatValue)) {
        formatValue = value;
      }
      if (enumName) {
        const enumObj = MSConstant[enumName];
        if (enumObj) {
          if (!Object.keys(enumObj)) {
            return '';
          }
          const key = Object.keys(enumObj).find(k => enumObj[k] === formatValue);
          if (key) {
            const rs = i18nEnum[enumName];
            if (rs) {
              const text = rs[key];
              return text;
            }
          } else {
            return formatValue;
          }
          // 	// return this.$t('i18nEnum.' + key + '');
        } else {
          return formatValue;
        }
      } else {
        return formatValue;
      }
    }
    return '';
  },
  /**
   * Thực hiện định dạng số tiền quy đổi theo hệ thống
   *
   */
  formatAmount(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToZero && num === 0) {
      return 0;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    //Nếu số tiền = 0 mà config isShowZero = false thì return '' luôn
    if (result == 0 && options && !options.isShowZero) {
      return '';
    }

    // ĐVThi sửa bug 90688- số lượng không hiển thị định dạng sau dấu chấm
    if (num != undefined && num != null) {
      const digits = useContextStore().NumberFormat.AmountDecimalDigits;
      const buildDigits = 0;

      // cũ đang hiện thị NaN, kiểm tra trường hợp số quá nhỏ thì trả về null nhhoang1 30.10.2024
      if (Number.isFinite(num) && Math.abs(num) < 1e-6) {
        if (options && !options.isShowZero) {
          return '';
        } else {
          return 0;
        }
      }

      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    //Nếu số tiền = 0 mà config isShowZero = false thì return '' luôn
    if (result == 0 && options && !options.isShowZero) {
      return '';
    }
    return result;
  },

  /**
   * Thực hiện định dạng số tiền nguyên tệ theo hệ thống
   */
  formatAmountOC(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToZero && num === 0) {
      return 0;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    //Nếu số tiền = 0 mà config isShowZero = false thì return '' luôn
    if (result == 0 && options && !options.isShowZero) {
      return '';
    }

    // ĐVThi sửa bug 90688- số lượng không hiển thị định dạng sau dấu chấm
    if (num != undefined && num != null) {
      const digits = useContextStore().NumberFormat.AmountOCDecimalDigits;
      const buildDigits = 0;

      this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },

  /**
   * Thực hiện định dạng số tiền nguyên tệ theo hệ thống
   */
  formatAllocation(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToZero && num === 0) {
      return 0;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    if (num != undefined && num != null) {
      const digits = useContextStore().NumberFormat.AllocationDecimalDigits;
      const buildDigits = 0;
      this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },

  /**
   * Thực hiện định dạng số lượng theo hệ thống
   */
  formatQuantity(num, options) {
    let result = num;
    // const dbOptions = store.state[ModuleDbOption]?.dbOptions;
    // if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
    //   return null;
    // }
    // if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToZero && num === 0) {
    //   return 0;
    // }

    // if (typeof num === 'undefined' || num === null) {
    //   return '-';
    // }

    // // ĐVThi sửa bug 90688- số lượng không hiển thị định dạng sau dấu chấm
    // if (num != undefined && num != null) {
    //   const digits = dbOptions.QuantityDecimalDigits || useContextStore().NumberFormat.QuantityDecimalDigits;
    //   const buildDigits = 0;
    //   this.formatSeperator(options);
    //   result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
    //   result = msFormat.formatNegative(result);
    // }

    return result;
  },
  /**
   * Thực hiện format kiểu số không có định dạng sau dấu chấm
   */
  formatNumber(num, options) {
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToZero && num === 0) {
      return 0;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    let result = num;

    if (num != undefined && num != null) {
      let digits = 0;
      const buildDigits = 0;
      if (options && options.digits) {
        digits = options.digits;
      }
      // this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },

  formatFloatNumber(number, options) {
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToZero && num === 0) {
      return 0;
    }
    // Chuyển đổi số thành chuỗi và tách phần nguyên và phần thập phân
    var parts = number.toString().split('.');
    var integerPart = parts[0];
    var decimalPart = parts.length > 1 ? parts[1] : '';

    // Thêm dấu "," phân cách hàng thập phân
    decimalPart = decimalPart.length > 0 ? ',' + decimalPart : '';

    // Thêm dấu "." phân cách hàng nghìn
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Kết hợp lại phần nguyên và phần thập phân
    return integerPart + decimalPart;
  },

  /**
   * Thực hiện định dạng số lượng theo hệ thống
   */
  formatExchangeRate(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    if (num != undefined && num != null) {
      const digits = useContextStore().NumberFormat.ExchangRateDecimalDigits;
      const buildDigits = 0;
      msFormat.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },
  /**
   * Thực hiện format định dạng đơn giá quy đổi
   */
  formatUnitPrice(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    if (num != undefined && num != null) {
      const digits = useContextStore().NumberFormat.UnitPriceDecimalDigits;
      const buildDigits = 0;
      this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },
  /**
   * Thực hiện format định dạng đơn giá nguyên tệ
   */
  formatUnitPriceOC(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && num === 0) {
      return null;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    if (num != undefined && num != null) {
      const digits = useContextStore().NumberFormat.UnitPriceOCDecimalDigits;
      const buildDigits = 0;
      this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },
  /**
   * Thực hiện format định dạng số của hệ số/tỷ lệ
   */
  formatCoefficient(num, options) {
    let result = num;

    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && !num) {
      return null;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    //Nếu số tiền = 0 mà config isShowZero = false thì return '' luôn
    if (result == 0 && options && !options.isShowZero) {
      return '';
    }

    if (num != undefined && num != null) {
      let digits = useContextStore().NumberFormat.CoefficientDecimalDigits;
      if (
        options.decimalPlacesCustom != -1 &&
        options.decimalPlacesCustom != null &&
        options.decimalPlacesCustom != undefined
      ) {
        digits = options.decimalPlacesCustom;
      }
      const buildDigits = 0;
      this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }

    return result;
  },

  /**
   * format số âm theo cấu hình
   */
  formatNegative(value) {
    if (value.startsWith('-')) {
      const CurrencyNegativePattern = 0;
      switch (CurrencyNegativePattern) {
        case 0:
          value = ['(', value.substr(1), ')'].join('');
          break;
        case 2:
          value = value.substr(1) + '-';
          break;
      }
    }

    return value;
  },

  /**
   * Join mảng thành chuỗi string theo dấu ;
   */
  formatJoinString(value) {
    try {
      let arr = value;
      if (typeof value === 'string') {
        arr = JSON.parse(value);
      }
      if (Array.isArray(arr)) {
        return arr.join('; ');
      }
    } catch (error) {
      return '';
    }
  },
  formatGroup(value) {
    if (value) {
      return value.substring(1, value.length - 1);
    }
  },
  formatTaxPeriod(value) {
    if (value && value.startsWith('00/')) {
      if (value.startsWith('00/QT/')) {
        return value.substring(6, value.length);
      } else if (value.startsWith('00/CN/')) {
        return value.substring(6, value.length);
      } else {
        return value.substring(3, value.length);
      }
    }
    return value;
  },
  formatEnumStatus(value, options) {
    if (typeof value == 'number' || value || typeof value == 'boolean') {
      const enumName = options.enumName || options.enum;
      let formatValue = Number(value);
      if (Number.isNaN(formatValue)) {
        formatValue = value;
      }
      if (enumName) {
        const enumObj = MSConstant[enumName];
        if (enumObj) {
          if (!Object.keys(enumObj)) {
            return '';
          }
          const key = Object.keys(enumObj).find(k => enumObj[k] === formatValue);
          if (key) {
            const text = i18nEnum[enumName][key];
            return text;
          } else {
            return formatValue;
          }
          // 	// return this.$t('i18nEnum.' + key + '');
        } else {
          return formatValue;
        }
      } else {
        return formatValue;
      }
    }
  },
  formatRomanize(num) {
    const lookup = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1,
    };
    let roman = '';
    let i;
    for (i in lookup) {
      while (num >= lookup[i]) {
        roman += i;
        num -= lookup[i];
      }
    }
    return roman;
  },
  formatDozens(value) {
    if (value < 10) {
      value = '0' + value;
    }
    return value;
  },
  /**
   * format hiển thị kích thước file
   */
  formatFileSize(value) {
    let size = value / 1024; // chia ra KB
    if (size > 1024) {
      size = size / 1024; // chia ra MB
      if (size > 1024) {
        size = Math.roundNumber(size / 1024, 1) + ' GB';
      } else {
        size = Math.roundNumber(size, 1) + ' MB';
      }
    } else {
      size = Math.roundNumber(size, 1) + ' KB';
    }
    return size;
  },
  /**
   * Format hiển thị phần trăm
   * @param {*} value
   * @return
   * tbngoc 12.07.2022
   */
  formatPercentage(num, options) {
    let result = num;
    //const dbOptions = store.state[ModuleDbOption]?.dbOptions;
    if (options && options.optionFormat == MSConstant.OptionFormat.ZeroToEmpty && !num) {
      return null;
    }

    if (typeof num === 'undefined' || num === null) {
      return '-';
    }

    //Nếu số tiền = 0 mà config isShowZero = false thì return '' luôn
    if (result == 0 && options && !options.isShowZero) {
      return '';
    }

    if (num != undefined && num != null) {
      //const digits = dbOptions.PercentDecimalDigits;
      let digits = useContextStore().NumberFormat.CoefficientDecimalDigits;
      if (
        options.decimalPlacesCustom != -1 &&
        options.decimalPlacesCustom != null &&
        options.decimalPlacesCustom != undefined
      ) {
        digits = options.decimalPlacesCustom;
      }
      const buildDigits = 0;
      this.formatSeperator(options);
      result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
      result = msFormat.formatNegative(result);
    }
    if(options && options.optionFormat == MSConstant.OptionFormat.HidePercentage) {
      return result;
    }
    return result + '%';
  },

  /**
   * Format về dạng String
   * @param {*} value
   * NVTUAN1 18.07.2022
   */
  formatText(value) {
    let result = '';

    if (typeof value === 'string') {
      return value;
    }

    if (value === null || value === undefined) {
      return result;
    }

    result = value.toString();

    return result;
  },
};
export function initFilter(app) {
  app.config.globalProperties.$ms = app.config.globalProperties.$ms || {};
  app.config.globalProperties.$ms.format = app.config.globalProperties.$ms.format || {};
  app.config.globalProperties.$ms.format.formatGroup = msFormat.formatGroup;

  app.config.globalProperties.$ms.format.formatTime = msFormat.formatTime;
  app.config.globalProperties.$ms.format.formatTimeFull = msFormat.formatTimeFull;
  app.config.globalProperties.$ms.format.formatDate = msFormat.formatDate;
  app.config.globalProperties.$ms.format.formatNull = msFormat.formatNull;
  // app.filter('formatTimes', msFormat.formatTimes)
  app.config.globalProperties.$ms.format.formatDateTimeFull = msFormat.formatDateTimeFull;
  app.config.globalProperties.$ms.format.formatDateTimeFullReverse = msFormat.formatDateTimeFullReverse;
  app.config.globalProperties.$ms.format.formatEnum = msFormat.formatEnum;
  app.config.globalProperties.$ms.format.formatAmount = msFormat.formatAmount;
  app.config.globalProperties.$ms.format.formatAmountOC = msFormat.formatAmountOC;
  app.config.globalProperties.$ms.format.formatAllocation = msFormat.formatAllocation;
  app.config.globalProperties.$ms.format.formatQuantity = msFormat.formatQuantity;
  app.config.globalProperties.$ms.format.formatExchangeRate = msFormat.formatExchangeRate;
  app.config.globalProperties.$ms.format.formatUnitPrice = msFormat.formatUnitPrice;
  app.config.globalProperties.$ms.format.formatUnitPriceOC = msFormat.formatUnitPriceOC;
  app.config.globalProperties.$ms.format.formatCoefficient = msFormat.formatCoefficient;
  app.config.globalProperties.$ms.format.formatJoinString = msFormat.formatJoinString;
  app.config.globalProperties.$ms.format.formatNumber = msFormat.formatNumber;
  app.config.globalProperties.$ms.format.formatFloatNumber = msFormat.formatFloatNumber;
  app.config.globalProperties.$ms.format.formatTaxPeriod = msFormat.formatTaxPeriod;
  app.config.globalProperties.$ms.format.formatEnumStatus = msFormat.formatEnumStatus;
  app.config.globalProperties.$ms.format.formatRomanize = msFormat.formatRomanize;
  app.config.globalProperties.$ms.format.formatFileSize = msFormat.formatFileSize;
  /**
   * Xử lý format cho các kiểu số
   * CreatedBy PDKIEN 21/12/2019
   */
  app.config.globalProperties.$ms.format.formatData = function (value, options = {}) {
    if (value === undefined || value === null) {
      return '';
    }

    let result;
    const msconst = MSConstant;

    switch (options.formatType) {
      case MSConstant.FormatType.Enum:
        result = msFormat.formatEnum(value, options.enumName);
        break;
      case MSConstant.FormatType.ExchangeRate:
        result = msFormat.formatExchangeRate(value, options);
        break;
      case MSConstant.FormatType.GroupItem:
        result = msFormat.formatGroup(value);
        break;
      case MSConstant.FormatType.DateTime:
        result = msFormat.formatDateTimeFull(value);
        break;
      case MSConstant.FormatType.DateTimeNotSecond:
        result = msFormat.formatDateTimeFullNotSecond(value);
        break;        
      case MSConstant.FormatType.Time:
        result = msFormat.formatTime(value, options.formatString);
        break;
      case MSConstant.FormatType.Rate:
        result = msFormat.formatCoefficient(value, options);
        break;
      case MSConstant.FormatType.Join:
        result = msFormat.formatJoinString(value);
        break;
      case MSConstant.FormatType.UnitPrice:
        result = msFormat.formatUnitPrice(value, options);
        break;
      case MSConstant.FormatType.Amount:
        result = msFormat.formatAmount(value, options);
        break;
      case MSConstant.FormatType.UnitPriceOC:
        result = msFormat.formatUnitPriceOC(value, options);
        break;
      case MSConstant.FormatType.AmountOC:
        result = msFormat.formatAmountOC(value, options);
        break;
      case MSConstant.FormatType.Allocation:
        result = msFormat.formatAllocation(value);
        break;
      case MSConstant.FormatType.Quantity:
        result = msFormat.formatQuantity(value, options);
        break;
      case MSConstant.FormatType.Number:
        result = msFormat.formatNumber(value, options);
        break;
      case MSConstant.FormatType.Date:
        result = msFormat.formatDate(value);
        break;
      case MSConstant.FormatType.FileSize:
        result = msFormat.formatFileSize(value);
        break;
      case MSConstant.FormatType.Checkbox:
        result = msFormat.formatCheckbox(value);
        break;
      case MSConstant.FormatType.Percentage:
        result = msFormat.formatPercentage(value, options);
        break;
      case MSConstant.FormatType.Text:
        result = msFormat.formatText(value);
        break;
      default:
        result = value;
        break;
    }
    return result;
  };
}

export default numeral;
export {msFormat};
